export function toRadians(degrees) {
    return degrees * Math.PI / 180;
}
export function toDegrees(radians) {
    return radians * 180 / Math.PI;
}
export function roundFloat(number, decimalPlaces) {
    if (decimalPlaces === void 0) { decimalPlaces = 9; }
    var sign = Math.sign(number);
    var p = Math.pow(10, decimalPlaces);
    var n = Math.abs(number) * p;
    return sign * Math.round(n) / p;
}
export function clamp(number, min, max) {
    return Math.max(min, Math.min(number, max));
}
export function range(start, stop, step) {
    return Array.from({ length: (stop - start) / step + 1 }, function (_, i) { return start + (i * step); });
}
//# sourceMappingURL=math-util.js.map